module.exports = __webpack_public_path__ + "img/orange-circle-table-5.a67d3073.png";